import React from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import "./mobile/mobile.css";
import MobileApp from "./mobile/MobileApp.jsx";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <MobileApp />
  </React.StrictMode>
);
